import { z } from 'zod'

export const AUTOMATION_INVOICE_FORMATION    = ['WHEN_CREATED', 'DAYS_BEFORE_PAYMENT', 'ON_PAYMENT_DAY'] as const
export const AUTOMATION_SEND_MODE            = ['AUTOMATIC', 'MANUAL', 'ON_CONFIRMATION'] as const
export const AUTOMATION_ACT_FORMATION        = ['ON_INVOICE_ISSUE', 'ON_PAYMENT', 'MANUAL'] as const
export const AUTOMATION_ACCRUAL_DISTRIBUTION = ['ALL_IN_ONE', 'SEPARATE_INVOICE_PER_TYPE'] as const
export const AUTOMATION_PAYMENT_DISTRIBUTION = ['PENALTY_FIRST', 'RENT_FIRST', 'UTILITIES_FIRST', 'PROPORTIONAL'] as const

export const automationUpsertSchema = z.object({
	paymentDay:                       z.number().int().min(1).max(31),
	invoiceFormation:                 z.enum(AUTOMATION_INVOICE_FORMATION),
	invoiceFormationDaysBefore:       z.number().int().min(0).max(31).optional(),
	sendToTenantMode:                 z.enum(AUTOMATION_SEND_MODE),
	sendToTenantAt:                   z.string().datetime({ offset: true }).optional(),
	actFormation:                     z.enum(AUTOMATION_ACT_FORMATION),
	accrualDistribution:              z.enum(AUTOMATION_ACCRUAL_DISTRIBUTION),
	reminderBeforeDaysBefore:         z.number().int().min(0).max(31).optional(),
	remindOnDueDate:                  z.boolean(),
	repeatReminderEveryDays:          z.number().int().min(1).max(31).optional(),
	repeatReminderMaxTimes:           z.number().int().min(1).max(20).optional(),
	paymentDistribution:              z.enum(AUTOMATION_PAYMENT_DISTRIBUTION),
	utilityReadingsRequestDaysBefore: z.number().int().min(0).max(31).optional(),
	utilityRemindOnCalculationDay:    z.boolean(),
	completionReminderDaysBefore:     z.number().int().min(0).max(120).optional(),
})
	// `DAYS_BEFORE_PAYMENT` requires the actual day count — backend defaults to 0 silently otherwise.
	.refine(
		(d) => d.invoiceFormation !== 'DAYS_BEFORE_PAYMENT' || d.invoiceFormationDaysBefore != null,
		{
			message: 'invoiceFormationDaysBefore is required when invoiceFormation = DAYS_BEFORE_PAYMENT',
			path:    ['invoiceFormationDaysBefore'],
		},
	)
	// Repeat-reminder fields go in pairs: either both are set, or neither.
	.refine(
		(d) => (d.repeatReminderEveryDays != null) === (d.repeatReminderMaxTimes != null),
		{
			message: 'repeatReminderEveryDays and repeatReminderMaxTimes must be set together',
			path:    ['repeatReminderEveryDays'],
		},
	)

export type AutomationUpsertInput = z.infer<typeof automationUpsertSchema>
